// Third party imports
import { createSlice } from "@reduxjs/toolkit";

// Initial state
const initialState = {
  subServiceTypes: [],
};

// Slice
const subServiceTypesSlice = createSlice({
  name: "subServiceTypes",
  initialState,
  reducers: {
    setSubServiceTypes: (state, action) => {
      state.subServiceTypes = action.payload;
    },
    clearSubServiceTypes: (state) => {
      state.subServiceTypes = [];
    },
  },
});

// Actions
export const { setSubServiceTypes, clearSubServiceTypes } = subServiceTypesSlice.actions;

// Reducer
export default subServiceTypesSlice.reducer;
